/**
 * The server's clock as this page best knows it, from the times public reads carry (the positions' and the standings'
 * `at`), so an age or a lower third's hold is measured on the server's time, not a viewer's wrong clock. Each `at` is
 * when the server built a cached answer, at or before the moment it answered, so every sample is a floor on the
 * offset: the largest of the last few is the best guess. With no sample yet the offset is 0, the viewer's own clock.
 */

const SAMPLES = 6
const samples: number[] = []

/** A server time read from a response, in epoch milliseconds, and when this page received it (now by default). */
export function noteServerTime(serverMs: number, receivedMs: number = Date.now()): void {
  if (!Number.isFinite(serverMs) || !Number.isFinite(receivedMs)) return
  samples.push(serverMs - receivedMs)
  if (samples.length > SAMPLES) samples.shift()
}

/** How far the server's clock is ahead of this page's, in milliseconds (0 before any sample). */
export function serverClockOffset(): number {
  return samples.length ? Math.max(...samples) : 0
}

/** Now on the server's clock, in epoch milliseconds. */
export function serverNow(): number {
  return Date.now() + serverClockOffset()
}

/** Forgets every sample (tests). */
export function resetServerClock(): void {
  samples.length = 0
}
